import { render } from "./ComponentSuggestionModal.vue?vue&type=template&id=87646bb0&scoped=true"
import script from "./ComponentSuggestionModal.vue?vue&type=script&lang=js"
export * from "./ComponentSuggestionModal.vue?vue&type=script&lang=js"

import "./ComponentSuggestionModal.vue?vue&type=style&index=0&id=87646bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87646bb0"]])

export default __exports__